import { render } from "./LeavePeriods.vue?vue&type=template&id=038fe96c"
import script from "./LeavePeriods.vue?vue&type=script&lang=js"
export * from "./LeavePeriods.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__